import { UseFormReturn, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { isValid, parse } from 'date-fns';

export enum DateFilterFieldNames {
  startDate = 'startDate',
  endDate = 'endDate',
}

type DateFilterForm = {
  startDate: string;
  endDate: string;
};

const getDateScheme = (name: string) =>
  yup
    .string()
    .test(name, ' ', async (value) => {
      if (!value) {
        return false;
      }

      if (value.length < 8) {
        return false;
      }

      return isValid(parse(value, 'LLddyyyy', new Date()));
    })
    .required('');

export const useDateFilterForm = (): UseFormReturn<DateFilterForm> => {
  const schema: yup.SchemaOf<DateFilterForm> = yup.object({
    startDate: getDateScheme('startDate'),
    endDate: getDateScheme('endDate'),
  });

  const form = useForm<DateFilterForm>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  return form;
};
